import { render, staticRenderFns } from "./ChannelStats.vue?vue&type=template&id=53ac1b32"
import script from "./ChannelStats.vue?vue&type=script&lang=js"
export * from "./ChannelStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports